import * as types from './types'

export default {
  [types.SET_ACCOUNT]: ({ commit, state },  users) => {
    if (state.$account && state.$account.id) {
      return users.getById(state.$account.id).then(user => {
        commit(types.SET_ACCOUNT, user)
      })
    } else {
      return Promise.reject(new Error('not-logged-in'))
    }
  },
  [types.SET_REQUIRED_PIN]: ({ commit }, value) => {
    commit(types.SET_REQUIRED_PIN, value)
  }
}
  